import React, { useState, useEffect } from 'react';
import { DEFAULT_GRID_COLUMNS, DEFAULT_GRID_ROWS } from '../../utils/constants';

/**
 * Modal pour configurer les paramètres de la grille (colonnes/lignes)
 */
export default function GridSettingsModal({
  isOpen,
  onClose,
  gridColumns,
  gridRows,
  onSave,
}) {
  const [localColumns, setLocalColumns] = useState(gridColumns);
  const [localRows, setLocalRows] = useState(gridRows);

  const handleReset = () => {
    setLocalColumns(DEFAULT_GRID_COLUMNS);
    setLocalRows(DEFAULT_GRID_ROWS);
  };

  // Synchroniser avec les props quand le modal s'ouvre
  useEffect(() => {
    if (isOpen) {
      setLocalColumns(gridColumns);
      setLocalRows(gridRows);
    }
  }, [isOpen, gridColumns, gridRows]);

  const handleSave = () => {
    // Validation
    const cols = parseInt(localColumns, 10);
    const rows = parseInt(localRows, 10);
    
    if (isNaN(cols) || cols < 4 || cols > 100) {
      alert('Le nombre de colonnes doit être entre 4 et 100');
      return;
    }
    if (isNaN(rows) || rows < 4 || rows > 100) {
      alert('Le nombre de lignes doit être entre 4 et 100');
      return;
    }
    
    onSave(cols, rows);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          padding: '24px',
          minWidth: '320px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          style={{
            margin: '0 0 20px 0',
            fontSize: '18px',
            fontWeight: '600',
            color: '#333',
          }}
        >
          Paramètres de la grille
        </h2>

        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              display: 'block',
              marginBottom: '6px',
              fontSize: '14px',
              fontWeight: '500',
              color: '#555',
            }}
          >
            Nombre de colonnes
          </label>
          <input
            type="number"
            value={localColumns}
            onChange={(e) => setLocalColumns(e.target.value)}
            min={4}
            max={100}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '14px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              boxSizing: 'border-box',
              outline: 'none',
            }}
            onFocus={(e) => (e.target.style.borderColor = '#007bff')}
            onBlur={(e) => (e.target.style.borderColor = '#ccc')}
          />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label
            style={{
              display: 'block',
              marginBottom: '6px',
              fontSize: '14px',
              fontWeight: '500',
              color: '#555',
            }}
          >
            Nombre de lignes
          </label>
          <input
            type="number"
            value={localRows}
            onChange={(e) => setLocalRows(e.target.value)}
            min={4}
            max={100}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '14px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              boxSizing: 'border-box',
              outline: 'none',
            }}
            onFocus={(e) => (e.target.style.borderColor = '#007bff')}
            onBlur={(e) => (e.target.style.borderColor = '#ccc')}
          />
        </div>

        <p
          style={{
            fontSize: '12px',
            color: '#888',
            marginBottom: '20px',
          }}
        >
          Note : Les positions existantes ne seront pas modifiées. Seule la grille d'affichage et l'aimantage changeront.
        </p>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            onClick={handleReset}
            style={{
              padding: '10px 16px',
              fontSize: '14px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              backgroundColor: '#fff',
              color: '#666',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              marginRight: 'auto',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#f0f0f0')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
            title={`Remettre les valeurs par défaut (${DEFAULT_GRID_COLUMNS} colonnes, ${DEFAULT_GRID_ROWS} lignes)`}
          >
            Réinitialiser
          </button>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              fontSize: '14px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              backgroundColor: '#fff',
              color: '#333',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#f0f0f0')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
          >
            Annuler
          </button>
          <button
            onClick={handleSave}
            style={{
              padding: '10px 20px',
              fontSize: '14px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: '#007bff',
              color: '#fff',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}
